module.exports = __webpack_public_path__ + "static/media/number-icon.5a8e4304.svg";